module.exports = __webpack_public_path__ + "src/assets/img/share/tips/pleasant/996b6a2188a260949559b97fc1263fab.png";